import React from "react"
import { useSpring, animated } from "react-spring"
import { inflateFromRight } from "./Animations"
import clsx from "clsx"
import useDeviceType from "../utils/useDeviceType"

function Header({ children, burgerAction = false }) {
  const { isMobileView } = useDeviceType()
  const pageStyle = useSpring(inflateFromRight)

  return (
    <animated.div
      className={clsx(
        "flex justify-between items-center bg-white",
        burgerAction ? "page-header-burger-menu" : "page-header"
      )}
      style={isMobileView ? pageStyle : {}}
    >
      {children}
    </animated.div>
  )
}

export default Header
